import { render } from "./todos.vue?vue&type=template&id=80df5532&scoped=true"
import script from "./todos.vue?vue&type=script&lang=js"
export * from "./todos.vue?vue&type=script&lang=js"

import "./todos.vue?vue&type=style&index=0&id=80df5532&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80df5532"]])

export default __exports__